<button
  nbButton
  ghost
  shape="semi-round"
  status="success"
  size="small"
  (click)="exportAsXLSX()"
>
  <nb-icon icon="download-outline"></nb-icon>
  {{ "buttons.downloadExcel" | translate }}
</button>
